<template>
  <div class="form-input">
    <BFormGroup
      :disabled="$attrs.disabled"
      :label-for="$attrs.id"
      :label-class="{
        'label-characters-limit': charactersLimit,
        'is-invalid': charactersLimit && state === false
      }"
    >
      <template
        v-if="finalErrorMessage"
        v-slot:invalid-feedback>
        <span v-html="finalErrorMessage" />
      </template>
      <template
        v-if="!charactersLimit && label"
        v-slot:label
      >
        {{ label }}
      </template>
      <template
        v-else-if="charactersLimit"
        v-slot:label
      >
        {{ label }}
        <span>{{ valueLength }}/{{ charactersLimit }}</span>
      </template>

      <BFormInput
        :value="value"
        :state="state"
        :autocomplete="$attrs.autocomplete"
        :aria-label="label || $attrs.placeholder"
        :class="$attrs['input-class'] || ''"
        v-bind="$attrs"
        v-on="$listeners"
      />
    </BFormGroup>
  </div>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue/src/components/form-group/form-group'
import {BFormInput} from 'bootstrap-vue/src/components/form-input/form-input'

export default {
  components: {
    BFormGroup,
    BFormInput,
  },
  inheritAttrs: false,

  props: {
    /**
     * The current value of the textarea. Result will always be a string.
     */
    value: {
      type: [String, Number],
      default: undefined,
    },

    /**
     * Text to place in the label/legend of the form group
     */
    label: {
      type: String,
      default: undefined,
    },

    /**
     * Controls the validation state appearance of the component. 'true' for valid, 'false' or 'null' for no validation state
     */
    isInvalid: {
      type: Boolean,
      default: false,
    },

    /**
     * Text to show when the form group has an invalid state
     */
    errorMessage: {
      type: String,
      default: undefined,
    },

    /**
     * Text to show when the form input has exceed the characters limit
     */
    charactersLimitMessage: {
      type: String,
      default: undefined,
    },

    /**
     * Characters limit
     */
    charactersLimit: {
      type: [String, Number],
      default: undefined,
    },
  },

  computed: {
    state () {
      const charactersLimit = this.charactersLimit | 0

      if (this.errorMessage && (this.errorMessage.length > 0)) {
        return false
      } else if (this.isInvalid) {
        return false
      } else if (charactersLimit > 0 && charactersLimit < this.valueLength) {
        return false
      } else {
        return null
      }
    },

    finalErrorMessage () {
      if (this.charactersLimitMessage && this.state === false) {
        return this.charactersLimitMessage
      } else {
        return this.errorMessage
      }
    },

    valueLength () {
      return this.value ? this.value.length : 0
    },
  },
}
</script>

<style lang="scss">
.form-input {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;

  &.is-invalid {
    input {
      border-color: $red-500;
    }
  }

  .label-characters-limit {
    display: flex !important;
    align-items: center;
    justify-content: space-between;

    &.is-invalid {
      span {
        color: $red-500;
      }
    }

    span {
      color: $gray-300;
    }
  }
}
</style>
